import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

// Sekundäre Routen erst bei Bedarf laden -> kleineres initiales Bundle.
const Audit = React.lazy(() => import("@/pages/Audit"));
const Demo = React.lazy(() => import("@/pages/Demo"));
const WhiteLabel = React.lazy(() => import("@/pages/WhiteLabel"));
const SeoBeispiel = React.lazy(() => import("@/pages/SeoBeispiel"));
const Impressum = React.lazy(() => import("@/pages/Impressum"));
const Datenschutz = React.lazy(() => import("@/pages/Datenschutz"));

function ScrollToTop() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}

function App() {
  const basename = process.env.PUBLIC_URL || "/";

  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <ScrollToTop />
        <React.Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/white-label" element={<WhiteLabel />} />
            <Route path="/seo-beispiel" element={<SeoBeispiel />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
